import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { HardDrive, ArrowLeft, Folder } from "lucide-react";

export default function PhotographerDashboard() {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  const [photographerEmail, setPhotographerEmail] = useState("");

  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_GOOGLE_REDIRECT_URI || "http://localhost:5173/auth/google/callback";

  const handleConnectDrive = () => {
    if (!eventId) {
      alert("Event ID tidak ditemukan");
      return;
    }

    // Generate crypto state untuk mencegah CSRF
    const oauthState = crypto.randomUUID();
    sessionStorage.setItem("gdrive_oauth_state", oauthState);

    // Simpan context fotografer ke localStorage sebelum redirect
    localStorage.setItem("pendingDriveUserId", photographerEmail || "photographer_demo");
    localStorage.setItem("pendingDriveEventId", eventId);

    const scope = encodeURIComponent("https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/userinfo.email");
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${scope}&access_type=offline&prompt=consent&state=${oauthState}`;
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b bg-white">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")}>
            <ArrowLeft className="w-4 h-4" />
          </Button>
          <span className="font-bold text-lg text-slate-900">Dashboard Fotografer</span>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8 space-y-6 w-full">
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <HardDrive className="w-5 h-5 text-blue-600" /> Koneksi Google Drive
            </CardTitle>
            <CardDescription>
              Hubungkan Google Drive Anda agar sistem otomatis memindai foto acara dan mencocokkan wajah tamu.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label className="text-xs font-medium text-slate-700">Email Fotografer / Identitas</label>
              <input
                type="email"
                value={photographerEmail}
                onChange={(e) => setPhotographerEmail(e.target.value)}
                placeholder="fotografer@gmail.com"
                className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="p-4 bg-slate-50 rounded-xl border flex flex-col sm:flex-row items-center justify-between gap-4">
              <div>
                <p className="font-semibold text-sm text-slate-900">Status: Belum Terhubung</p>
                <p className="text-xs text-slate-500 mt-0.5">
                  Hubungkan akun Google Drive fotografer untuk mulai sinkronisasi folder foto.
                </p>
              </div>
              <Button onClick={handleConnectDrive} className="gap-2 shrink-0">
                Hubungkan Google Drive
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Info Sinkronisasi */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Folder className="w-5 h-5 text-indigo-600" /> Folder Acara Terpilih
            </CardTitle>
            <CardDescription>Pilih folder Google Drive tempat Anda mengunggah hasil foto acara ini</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-center py-8 text-slate-400 text-xs border-2 border-dashed rounded-xl">
              Hubungkan Google Drive terlebih dahulu untuk memilih folder foto acara.
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}